import React from 'react'
import { Container } from "reactstrap";
import { Row, Col } from "react-bootstrap";
import convertToArray from "../utils/convertToArray";

export default class Messages extends React.Component {
    constructor() {
        super();
        this.state = {
            messages: []
        };
    }
    componentWillMount() {
        this.fetchNewMessages();
    }
    fetchNewMessages() {
        fetch("https://us-central1-portfolio-336c8.cloudfunctions.net/getMessages").then(res => res.json()).then(data => {
            if (data.messages) this.setState({ messages: convertToArray(data.messages) });
        });
    }
    deleteMessage = (id) => {
        fetch(`https://us-central1-portfolio-336c8.cloudfunctions.net/deleteMessage?messageId=${id}`).then(res => { this.fetchNewMessages(); });
    }
    render() {
        return (
            <Container style={styles.mainContainer}>
                <h1 style={styles.mainHeading}>All Messages</h1>
                {
                    this.state.messages.length ?
                        <div>
                            {this.state.messages.map((message, i) =>
                                <Row key={i}>
                                    <Col xs={11} sm={11} md={11}>
                                        <div style={styles.messageContainer}>
                                            <p><span style={styles.typeRepresentation}>Name:</span> {message.name}</p>
                                            <p><span style={styles.typeRepresentation}>Email:</span> {message.email}</p>
                                            <p><span style={styles.typeRepresentation}>Message:</span> {message.message}</p>
                                        </div>
                                    </Col>
                                    <Col xs={1} sm={1} md={1}>
                                        <a href="JavaScript:void(0)" onClick={_ => {
                                            this.deleteMessage(message.id);
                                        }}>
                                            <i className="fas fa-trash-alt" style={styles.messageDeleteIcon}></i>
                                        </a>
                                    </Col>
                                </Row>
                            )}
                        </div>
                        : <div></div>
                }
            </Container>
        );
    }
}

const styles = {
    mainContainer: {
        fontFamily: "Roboto Slab, sans-serif"
    },
    mainHeading: {
        color: "#3c4858",
        fontSize: 43,
        fontWeight: 700
    },
    messageContainer: {
        width: "100%",
        boxShadow: "5px 5px 10px 3px grey",
        marginTop: 15,
        padding: 10
    },
    typeRepresentation: {
        fontWeight: "bold"
    },
    messageDeleteIcon: {
        color: "red",
        fontSize: 16,
        position: "relative",
        top: "50%",
        transform: "translateY(350%)",
        cursor: "pointer",
        right: 9
    }
};


// WEBPACK FOOTER //
// ./src/Components/messages.jsx